import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import PageTitle from "./components/PageTitle";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  SubTitle,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

import api from "../api/api";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  SubTitle,
  Title,
  Tooltip,
  Legend
)

const createOptions = (title: string, subtitle: string) => {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title
      },
      subtitle: {
        display: true,
        text: subtitle,
      }
    },
  }
}

const labels = ["Q1 '21", "Q2 '21", "Q3 '21", "Q4 '21", "Q1 '22", "Q2 '22", "Q3 '22", "Q4 '22", "Q1 '23"];

const targetLineColor = {
  borderColor: 'rgba(255, 165, 0, 1)',
  backgroundColor: 'rgba(255, 165, 0, 1)',
}

const actualLineColor = {
  borderColor: 'rgba(0, 255, 0, 1)',
  backgroundColor: 'rgba(0, 255, 0, 1)',
}

type Kpi = {
  actual: Number[];
  target: Number[];
}

type KpiChartData = {
  activeEngagements: Kpi;
  activeClients: Kpi;
}

function AdminKPIsPage(_props: any) {
  const [kpiChartData, setKpiChartData] = useState<KpiChartData | null>(null);
  useEffect(() => {
    api.admin.fetchKpis()
      .then((response: KpiChartData) => {
        setKpiChartData(response);
      })
  }, []);

  return (
    <Box>
      <PageTitle>KPIs</PageTitle>
      <Grid container spacing={4} sx={{ mb: 2 }}>
        <Grid item sm={6}>

          <Line
            options={createOptions("# of Active Engagements", "Measured at the beginning of the quarter")}
            data={{
              labels,
              datasets: [
                {
                  label: 'Actual',
                  data: kpiChartData?.activeEngagements.actual,
                  ...actualLineColor,
                },
                {
                  label: 'Target',
                  data: kpiChartData?.activeEngagements.target,
                  ...targetLineColor,
                },
              ]
            }}
          />
        </Grid>
        <Grid item sm={6}>

          <Line
            options={createOptions("# of Active Clients", "Measured at the beginning of the quarter")}
            data={{
              labels,
              datasets: [
                {
                  label: 'Actual',
                  data: kpiChartData?.activeClients.actual,
                  ...actualLineColor,
                },
                {
                  label: 'Target',
                  data: kpiChartData?.activeClients.target,
                  ...targetLineColor,
                },
              ]
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default AdminKPIsPage;
